import { LookupType } from '../lookup/lookup-type';

export enum AlertStatus {
  Scheduled = 1,
  Active,
  Past,
}

export interface Alert {
  id?: number;
  title?: string;
  title_Fr?: string;
  startDate?: string;
  endDate?: string;
  statusId?: number;
  status?: LookupType;
}
